import Vue from 'vue';
import keyFrame from 'create-keyframe-animation';

import { isEqual, forEach } from 'lodash';

import taskManager from '@/utils/task-manager';
import { booleanDefine } from '@/utils/boolean';

import EventlevelAPI from '@/api/model/eventlevel';

const TASK_NAME = 'glow-keyframe';
const INTERVAL = 60;

let inst = null;

export default {
  create() {
    inst = new Vue({
      data() {
        return {
          eventlevel: null,
        };
      },
      created() {
        this.reloadEventlevel();
        this.createTask();
      },
      beforeDestroy() {
        this.removeTask();
      },
      methods: {
        createTask() {
          taskManager.createTask(TASK_NAME, INTERVAL, () => {
            this.reloadEventlevel();
          });
          taskManager.startTask(TASK_NAME);
        },
        removeTask() {
          taskManager.removeTask(TASK_NAME);
        },
        reloadEventlevel() {
          EventlevelAPI.getList(booleanDefine.TRUE_Y).then((response) => {
            if (response.data.success) {
              const tmpEventlevel = response.data.data;

              if (this.eventlevel) {
                if (isEqual(this.eventlevel, tmpEventlevel) === false) { // 이전에 조회 한 내용과 다를 경우 keyFrame을 새롭게 정의한다.
                  this.eventlevel = tmpEventlevel;

                  this.setGlowKeyframe();
                }
              } else {
                this.eventlevel = tmpEventlevel;

                this.setGlowKeyframe();
              }
            }
          });
        },
        setGlowKeyframe() {
          forEach(this.eventlevel, (item) => {
            const eventlevelId = item.eventlevelId;
            const eventlevelColor = item.eventlevelColorBg;
            const keyframeName = `GLOW-${eventlevelId}`;

            this.setKeyframe(keyframeName, eventlevelColor);
          });
        },
        setKeyframe(name, color) {
          keyFrame.registerAnimation({
            name,
            // the actual array of animation changes
            animation: {
              0: {
                filter: `
                drop-shadow(0px 0px 0.5em ${color})
                drop-shadow(0px 0px 0.5em ${color})
                drop-shadow(0px 0px 0.5em ${color})
                drop-shadow(0px 0px 1em ${color})
                drop-shadow(0px 0px 1em ${color})
                drop-shadow(0px 0px 1em ${color})
                `,
              },
              50: {
                filter: `
                drop-shadow(0px 0px 1px ${color})
                drop-shadow(0px 0px 1px ${color})
                drop-shadow(0px 0px 1px ${color})
                `,
              },
              100: {
                filter: `
                drop-shadow(0px 0px 0.5em ${color})
                drop-shadow(0px 0px 0.5em ${color})
                drop-shadow(0px 0px 0.5em ${color})
                drop-shadow(0px 0px 1em ${color})
                drop-shadow(0px 0px 1em ${color})
                drop-shadow(0px 0px 1em ${color})
                `,
              },
            },
          });
        },
      },
    });
  },
  setGlowKeyframe(name, color) {
    if (inst !== null) {
      inst.setKeyframe(`GLOW-${name}`, color);
    }
  },
  destroy() {
    if (inst !== null) {
      inst.$destroy();
    }
  },
};



// WEBPACK FOOTER //
// ./src/views/dashboard/js/glow-keyframe.js